<footer class="footer">
    <div class="footer__content">
        <a
            class="footer__brand"
            href="https://www.surefiresoftware.co.uk"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit the SureQuote website">
            <img src="/images/surequote-logo.svg" alt="SureQuote" />
        </a>

        <!-- prettier-ignore -->
        <p>
            Created using
            <a href="https://www.surefiresoftware.co.uk" target="_blank" rel="noopener noreferrer">SureQuote</a>, intelligent quoting software by
            <a href="https://www.surefiresoftware.co.uk" target="_blank" rel="noopener noreferrer">Surefire</a>.
        </p>
    </div>
</footer>
